"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFields = exports.isHidden = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const react_1 = tslib_1.__importDefault(require("react"));
const getFormField_1 = require("./getFormField");
/**
 * Determines if a field should be hidden based on the displayOptions
 * @param values
 * @param displayOptions
 */
function isHidden(values = {}, displayOptions) {
    const hide = lodash_get_1.default(displayOptions, 'hide');
    const show = lodash_get_1.default(displayOptions, 'show');
    if (hide) {
        return Object.keys(hide).map(i => hide[i].findIndex(j => j === values[i])).findIndex(i => i >= 0) >= 0;
    }
    if (show) {
        return Object.keys(show).map(i => show[i].findIndex(j => j === values[i])).findIndex(i => i >= 0) < 0;
    }
    return false;
}
exports.isHidden = isHidden;
/**
 * A component that takes care of field resolution and rendering logic.
 * This component follows the render prop pattern and gives a renderField
 * function as a param.
 */
const FormFields = (props) => {
    const { FieldWrapper, children, fields = [], fieldTypes } = props, rest = tslib_1.__rest(props, ["FieldWrapper", "children", "fields", "fieldTypes"]);
    const BB = core_1.useBlueBase();
    const { __ } = core_1.useIntl();
    const { values } = formik_1.useFormikContext();
    const renderField = (fieldInput, index) => {
        const { displayOptions } = fieldInput, fieldOpts = tslib_1.__rest(fieldInput, ["displayOptions"]);
        const field = Object.assign(Object.assign(Object.assign({}, rest), fieldInput), { name: fieldInput.name || `${index}-${fieldInput.type}`, 
            // Translate
            helperText: fieldInput.helperText ? __(fieldOpts.helperText) : fieldOpts.helperText, label: fieldOpts.label ? __(fieldOpts.label) : fieldOpts.label, placeholder: fieldOpts.placeholder ? __(fieldOpts.placeholder) : fieldOpts.placeholder, title: fieldOpts.title ? __(fieldOpts.title) : fieldOpts.title });
        const key = field.name;
        const Component = BB.Components.resolveFromCache(...getFormField_1.getFormField(field.type, fieldTypes));
        const fieldNode = react_1.default.createElement(Component, Object.assign({ key: key }, field, { fieldTypes: fieldTypes }));
        if (isHidden(values, field.displayOptions)) {
            return null;
        }
        return FieldWrapper ? (react_1.default.createElement(FieldWrapper, { key: key, field: field, parent: props }, fieldNode)) : (fieldNode);
    };
    if (children) {
        return children(renderField);
    }
    return fields.map(renderField);
};
exports.FormFields = FormFields;
exports.FormFields.displayName = 'FormFields';
